import { useState, useEffect } from 'react';
import { Report } from '../../../lib/types';
import { FamlaServices } from '../../../../services';

export const useReports = (mapId: string, users: any, AnalyseId: string) => {
    const [report, setReport] = useState<Report[]>([]);

    const [isLoadingReports, setIsLoadingReports] = useState(true);

    useEffect(() => {
        const loadAllAnalysies = async () => {
            const endpointFromMap = `/report/saved/map/${mapId}`;

            try {
                if (AnalyseId) {
                    // Étape 1 : Charger le rapport pour obtenir son analysis_id
                    const reportResponse = await FamlaServices(
                        "api_host",
                        `/report/report/by/id/{process_id}?report_id=${AnalyseId}`,
                        "GET",
                        "",
                        users.access_token
                    );

                    if (reportResponse.status === 200) {
                        const singleReport = reportResponse.body.data;
                        const analysisId = singleReport.analysis_id;

                        if (analysisId) {
                            // Étape 2 : Charger TOUS les rapports de cette analyse
                            const allReportsResponse = await FamlaServices(
                                "api_host",
                                `/report/by/analysis/${analysisId}`,
                                "GET",
                                "",
                                users.access_token
                            );

                            if (allReportsResponse.status === 200) {
                                const allReports = allReportsResponse.body.data;
                                // Trier par date de création (chronologique)
                                const sortedReports = Array.isArray(allReports)
                                    ? allReports.sort((a: Report, b: Report) =>
                                        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
                                    )
                                    : [allReports];
                                setReport(sortedReports);
                            } else {
                                // Fallback : afficher au moins le rapport chargé
                                setReport([singleReport]);
                            }
                        } else {
                            // Pas d'analysis_id → afficher uniquement ce rapport
                            setReport([singleReport]);
                        }
                    }
                } else {
                    // Pas d'AnalyseId → charger tous les rapports sauvegardés du map
                    const response = await FamlaServices("api_host", endpointFromMap, "GET", "", users.access_token);

                    if (response.status === 200) {
                        const reportData = response.body.data;
                        setReport(reportData);
                    }
                }
            } catch (error) {
                console.error('❌ Erreur lors du chargement des rapports:', error);
            } finally {
                setIsLoadingReports(false);
            }

        };
        loadAllAnalysies();
    }, [mapId, users.access_token, AnalyseId]);

    return {
        report,
        setReport,
        isLoadingReports,
    };
};